import React from "react";
import "./financialsInfo.css";
import { useSelector, useDispatch } from "react-redux";
import { updatefinancialAnalysis } from "../../../Features/roofInfo";
import CustomInput from "../../../component/customInput";
import { Select, MenuItem } from "@mui/material";
import CustomInputLabel from "../../../component/customInputLabel";
import { currencyOpt } from "./currencyInfo";

export default function InfoContainer({ emptyValues }) {
  const dispatch = useDispatch();
  const roofInfo = useSelector((state) => state.roof);

  const currency = roofInfo?.value?.financialAnalysis?.currency || "PKR";

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (value === "" || isNaN(parseFloat(value))) {
      dispatch(updatefinancialAnalysis({ [name]: 0 }));
    } else {
      let val = String(value);
      if (
        val[0] === "0" &&
        val[1] !== "." &&
        val.length > 1 &&
        val.length < 3
      ) {
        val = val.slice(1);
      }
      dispatch(updatefinancialAnalysis({ [name]: val }));
    }
  };

  const handleCustomRoi = (event) => {
    const val = Number(event.target.value);
    dispatch(updatefinancialAnalysis({ roiYears: val }));
  };

  const handleCurrency = (e) => {
    const val = e.target.value;
    dispatch(updatefinancialAnalysis({ currency: val }));
  };

  return (
    <div className="FinfoContainer">
      <div className="siteDetail">
        <h1>Financial and Energy Analysis</h1>
        <CustomInputLabel title={"ROI Currency"} isRequired={false} />
        <Select
          id="Currency"
          value={currency}
          name="currency"
          onChange={handleCurrency}
          sx={{ width: 240 }}
        >
          {currencyOpt.map((item) => (
            <MenuItem key={item.code} value={item.code}>
              {item.label}
            </MenuItem>
          ))}
        </Select>
        <CustomInputLabel title={"Custom Roi Option"} isRequired={false} />
        <Select
          id="Custom Roi Option"
          value={roofInfo?.value?.financialAnalysis?.roiYears || 20}
          name="roiYears"
          onChange={handleCustomRoi}
          sx={{ width: 240 }}
        >
          <MenuItem value={10}>10</MenuItem>
          <MenuItem value={15}>15</MenuItem>
          <MenuItem value={20}>20</MenuItem>
        </Select>
        <CustomInput
          type="number"
          name="tpc"
          value={roofInfo.value.financialAnalysis.tpc}
          onChange={handleInputChange}
          title={`Estimated Project Cost (${currency})`}
          width="240px"
        />
        <CustomInput
          type="number"
          name="et"
          value={roofInfo.value.financialAnalysis.et}
          onChange={handleInputChange}
          title={"Electricity Tariff (Price/Unit)"}
          width="240px"
        />
        <CustomInput
          type="number"
          name="aeci"
          value={roofInfo.value.financialAnalysis.aeci}
          onChange={handleInputChange}
          title={"Anticipated Electricity Cost Increase /Year (%)"}
          width="240px"
        />
        <CustomInput
          type="number"
          name="exportTriff"
          value={roofInfo.value.financialAnalysis.exportTriff}
          onChange={handleInputChange}
          title={"Export Tariff (Price/Unit)"}
          width="240px"
        />
        <CustomInput
          type="number"
          name="aetIncrease"
          value={roofInfo.value.financialAnalysis.aetIncrease}
          onChange={handleInputChange}
          title={"Anticipated Export Tariff Increase (Price/Unit)"}
          width="240px"
        />
        <CustomInput
          type="number"
          name="maintenceCost"
          value={roofInfo.value.financialAnalysis?.maintenceCost || 0}
          onChange={handleInputChange}
          title={"Project Maintence Cost"}
          width="240px"
        />
      </div>
    </div>
  );
}
